import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { WorkspaceBrand } from "@/components/workspace/WorkspaceShell";
import "@/components/workspace/workspace.css";

const ResetPassword = () => {
  const navigate = useNavigate();

  // Redirect to login after a short delay
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/login");
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="et-auth">
      <div className="et-auth-form-side">
        <div className="et-auth-form">
          <WorkspaceBrand />
          <div className="et-auth-fields">
            <h2 className="text-xl font-bold text-gray-900 mb-4">
              Password Reset Updated
            </h2>
            <p className="text-gray-600 mb-6">
              Password reset now uses a verification code sent to your email.
              Please go to the login page and click "Forgot Password?" to reset
              your password.
            </p>
            <button
              onClick={() => navigate("/login")}
              className="bg-[#28543D] text-white font-semibold px-6 py-3 rounded-lg hover:bg-[#204833] transition-colors duration-200"
            >
              Go to Login
            </button>
          </div>
        </div>
      </div>
      <aside className="et-auth-art">
        <img src="/design/learning-globe.webp" alt="" loading="lazy" />
        <p>
          A bold new future for
          <br />
          <em>1:1 learning.</em>
        </p>
      </aside>
    </div>
  );
};

export default ResetPassword;
